import React from 'react';
import { DropdownItem, RenderPartHightlightMatch } from './SearchableDropdown';

export const DateDropdownItem = ({
  item,
  searchTerm,
  itemHasFocus,
  smallFontOnSmallScreens = false,
}) => (
  <DropdownItem
    itemHasFocus={itemHasFocus}
    key={searchTerm}
    smallFontOnSmallScreens={smallFontOnSmallScreens}
  >
    <RenderPartHightlightMatch
      contentWrapperStyle={{ textAlign: 'left', marginLeft: '5px' }}
      part={item.formatted + (item.extra ? item.extra : '')}
      searchTerm={searchTerm}
    />
  </DropdownItem>
);
